import Immutable from 'immutable';

import StudentGeneralInfo from 'domain/StudentGeneralInfo';
import StudentPerformance from './';
import { ACH } from './model';
import Rewards from '../Rewards/model';

const reviver = ([key, item]) => {
  if (! item) return [key, item];
  switch (key) {
    case 'studentGeneralInfo':
      return [key, StudentGeneralInfo.create(item)];
    case 'ach':
      return [key, new ACH(item)];
    case 'rewards':
      return [key, Rewards.create(item)];
    default:
      return [key, Immutable.fromJS(item)];
  }
};

export const create = (data) =>
  new StudentPerformance(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/GroupPerformance/StudentPerformance/create.js